import React, { useState, useEffect, Fragment } from "react";
import cloneDeep from "lodash.clonedeep";
import { Button, Icon, Input, Row, Col } from 'antd';
import TranslatedText from "translations/TranslatedText";

export default function URLConfig(props) {
  const {
    mediaFiles,
    onChange,
  } = props;
  const [media, setMedia] = useState(mediaFiles);

  const parseUrl = (url, index) => {
    const clonedMedia = cloneDeep(media);
    clonedMedia[index].src = url;
    setMedia(clonedMedia);
  }

  const addRow = () => {
    console.log('add row ', media.length);
    const clonedMedia = cloneDeep(media);
    clonedMedia.push({
      title: "",
      src: "",
    });
    setMedia(clonedMedia);
  }

  const removeRow = (index) => {
    console.log('remove row ', index);
    const clonedMedia = cloneDeep(media);
    clonedMedia.splice(index, 1);
    setMedia(clonedMedia);
  }

  useEffect(() => {
    onChange(media);
  }, [media]);

  return (
    <Fragment>
      {
        media.map((mediaItem, index) => {
          return (
            <Fragment key={index}>
              <Row type="flex" justify="start" align="middle">
                <Col>
                  <Input
                    onChange={(event: any)=>parseUrl(event.target.value, index)}
                    value={mediaItem.src}
                    addonBefore={<TranslatedText id={"settings.form.imageslideshow.row.label"} />}
                  />
                </Col>
                <Col>
                  <Fragment>
                    <Button onClick={addRow}>
                      <Icon type="plus-circle" />
                    </Button>
                    {media.length > 1 && (
                      <Button onClick={()=>removeRow(index)}>
                        <Icon type="minus-circle" />
                      </Button>
                    )}
                  </Fragment>
                </Col>
              </Row>
            </Fragment>
          )
        })
      }
    </Fragment>
  );
}